import Cropper from 'cropperjs';

export interface IAllCropperData {
    data: Cropper.Data;
    cropBoxData: Cropper.CropBoxData;
    canvasData: Cropper.CanvasData;
}

export enum EPhotoReviewMode {
    view,
    edit
}

export interface ICropperViewData {
    width: number;
    height: number;
}

export interface ICropBoxViewData  {
    height: number;
    left: number;
    top: number;
    width: number;
}

export interface ICropData {
    x: number;
    y: number;
    width: number;
    height: number;
    rotate: number;
    scaleX: number;
    scaleY: number;
}
